import { render, staticRenderFns } from "./PaginationTableau.vue?vue&type=template&id=4539d0f0&lang=pug"
import script from "./PaginationTableau.vue?vue&type=script&lang=js"
export * from "./PaginationTableau.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4539d0f0')) {
      api.createRecord('4539d0f0', component.options)
    } else {
      api.reload('4539d0f0', component.options)
    }
    module.hot.accept("./PaginationTableau.vue?vue&type=template&id=4539d0f0&lang=pug", function () {
      api.rerender('4539d0f0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/PaginationTableau.vue"
export default component.exports